import styled from '@emotion/styled'

import { NavigationCloseIcon } from '@arcade/web/icons/react'

const ModalHeaderRow = styled.div<{ disableFullScreenModal?: boolean; isDesktop?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.m};
  background: inherit;
  top: 0;

  ${props =>
    (props.disableFullScreenModal || props.isDesktop) &&
    `
    padding: ${props.theme.spacing.l};
    padding-bottom: ${props.theme.spacing.xs};
  `}
`

const CloseButton = styled.button`
  appearance: none;
  cursor: pointer;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background: inherit;
  border: none;
  outline-style: none;
  padding: ${({ theme }) => theme.spacing.empty};
  color: ${props => props.theme.colors.icon};
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  :disabled {
    cursor: not-allowed;
  }

  ${props => props.theme.selectors.keyboard} &:focus {
    outline-style: auto;
  }
`

export interface ModalHeaderProps {
  disableClose?: boolean
  onClose: () => void
  'aria-label'?: string
  disableFullScreenModal?: boolean
  isDesktop?: boolean
}

/**
 * @deprecated Use ArcadeModalHeader instead
 */
const ModalHeader = ({
  disableClose,
  onClose,
  'aria-label': ariaLabel = 'close',
  disableFullScreenModal,
  isDesktop,
}: ModalHeaderProps) => (
  <ModalHeaderRow disableFullScreenModal={disableFullScreenModal} isDesktop={isDesktop}>
    <CloseButton disabled={disableClose} onClick={disableClose ? () => null : onClose} aria-label={ariaLabel}>
      <NavigationCloseIcon size={24} />
    </CloseButton>
  </ModalHeaderRow>
)

export default ModalHeader
